import { render, staticRenderFns } from "./UnitHeadlineForm.vue?vue&type=template&id=5a5d9335&scoped=true&"
import script from "./UnitHeadlineForm.vue?vue&type=script&lang=js&"
export * from "./UnitHeadlineForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5d9335",
  null
  
)

export default component.exports